import actions from './actions';

const {
  GET_DALEEL_STORE_BALANCE_BEGIN,
  GET_DALEEL_STORE_BALANCE_SUCCESS,
  GET_DALEEL_STORE_BALANCE_ERR,
  GET_DALEEL_STORE_MERCHANTS_BEGIN,
  GET_DALEEL_STORE_MERCHANTS_SUCCESS,
  GET_DALEEL_STORE_MERCHANTS_ERR,
  GET_DALEEL_STORE_PRODUCTS_BEGIN,
  GET_DALEEL_STORE_PRODUCTS_SUCCESS,
  GET_DALEEL_STORE_PRODUCTS_ERR,
} = actions;

const initState = {
  loadingGetDaleelStoreBalance: false,
  errorGetDaleelStoreBalance: null,
  balance: 0,

  loadingGetDaleelStoreMerchants: false,
  errorGetDaleelStoreMerchants: null,
  merchants: [],

  loadingGetDaleelStoreProducts: false,
  errorGetDaleelStoreProducts: null,
  products: [],
};

/**
 *
 * @todo impure state mutation/explaination
 */
const daleelStoreReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_DALEEL_STORE_MERCHANTS_BEGIN:
      return {
        ...state,
        loadingGetDaleelStoreMerchants: true,
        errorGetDaleelStoreMerchants: null,
      };
    case GET_DALEEL_STORE_MERCHANTS_SUCCESS:
      return {
        ...state,
        merchants: data,
        loadingGetDaleelStoreMerchants: false,
        errorGetDaleelStoreMerchants: null,
      };
    case GET_DALEEL_STORE_MERCHANTS_ERR:
      return {
        ...state,
        loadingGetDaleelStoreMerchants: false,
        errorGetDaleelStoreMerchants: err,
      };

    case GET_DALEEL_STORE_BALANCE_BEGIN:
      return {
        ...state,
        loadingGetDaleelStoreBalance: true,
        errorGetDaleelStoreBalance: null,
      };
    case GET_DALEEL_STORE_BALANCE_SUCCESS:
      return {
        ...state,
        balance: data,
        loadingGetDaleelStoreBalance: false,
        errorGetDaleelStoreBalance: null,
      };
    case GET_DALEEL_STORE_BALANCE_ERR:
      return {
        ...state,
        loadingGetDaleelStoreBalance: false,
        errorGetDaleelStoreBalance: err,
      };

    case GET_DALEEL_STORE_PRODUCTS_BEGIN:
      return {
        ...state,
        loadingGetDaleelStoreProducts: true,
        errorGetDaleelStoreProducts: null,
      };
    case GET_DALEEL_STORE_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: data,
        loadingGetDaleelStoreProducts: false,
        errorGetDaleelStoreProducts: null,
      };
    case GET_DALEEL_STORE_PRODUCTS_ERR:
      return {
        ...state,
        loadingGetDaleelStoreProducts: false,
        errorGetDaleelStoreProducts: err,
      };
    default:
      return state;
  }
};
export { daleelStoreReducer };
